import { Type, ContentChildren } from '@angular/core';
export class EquipmentLog {


  handOut: string;
  takeBack: string;

  note: string;

  constructor(data?: any) {
    if (data) {
      this.handOut = data.handOut;
      this.takeBack = data.takeBack;
      this.note = data.note;
    }
  }
}

export class EquipmentIdentifier {
  id: number;
  typ: EquipmentIdentifier;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.typ = data.typ;
    }
  }
}

export enum EquipmentType {
  SmartPhone = 'SMART_PHONE',
  SupplementaryEquipment = 'SUPPLEMENTARY_EQUIPMENT',
  Pager = 'PAGER',
}
